var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":"","disabled":_vm.valid || _vm.toolTipText.length < 1,"color":"error"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"next__btn",attrs:{"color":"success","disabled":!_vm.valid},on:{"click":_vm.clickHandler}},on),[_vm._v(_vm._s(_vm.btnText))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.toolTipText))])])}
var staticRenderFns = []

export { render, staticRenderFns }